/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankListItemViewModel } from "../types/BankListItemViewModel.ts";

export const bankListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.optional(z.number().int()),
  agency: z.string().nullish(),
  accountNumber: z.string().nullish(),
  name: z.string().nullish(),
  merchant: z.string().nullish(),
  phone: z.string().nullish(),
  companyId: z.number().int().nullish(),
  companyName: z.string().nullish(),
}) as unknown as ToZod<BankListItemViewModel>;
